var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box",class:[_vm.hostClass, _vm.isPhone ? 'm' : ''],attrs:{"id":"box"}},[_c('i',{staticClass:"bg"}),_c('iframe',{staticClass:"support-page",attrs:{"src":_vm.supportUrl,"id":"support-page"}})])}
var staticRenderFns = []

export { render, staticRenderFns }